import LearnCenter from 'components/pages/Dashboard/common/LearnCenter';
import YourResources from 'components/pages/Dashboard/common/YourResources';
import AdditionalProducts from 'components/pages/Dashboard/complete/AdditionalProducts';

import useResources from 'hooks/useResources';

export default function InitialPage() {
    const { t } = useResources();

    return (
        <div className="mt-3">
            <AdditionalProducts />
            <YourResources />
            <LearnCenter articles={t('newDashboardPage.learnCenter.articles', { returnObjects: true })} />
        </div>
    );
}
